<script setup lang="ts">
  import { useBreakpoint } from "@/lib/useBreakpoint.ts"
  import { useNavigationItems } from "@/lib/useNavigationItems.ts"
  import { cn } from "@/lib/utils.ts"
  import { computed } from "vue"
  import { useRoute } from "vue-router"
  import UserInfoCard from "@/components/cards/UserInfoCard.vue"
  import SidebarItem from "@/components/sidebar/SidebarItem.vue"
  import { Card } from "@/components/ui/card"

  import SidebarItemsSkeleton from "./SidebarItemsSkeleton.vue"

  const route = useRoute()
  const isDesktop = useBreakpoint("md")
  const { sidebarNavigationItems, isLoading } = useNavigationItems()

  const showMobileUserInfoCard = computed(
    () => route.meta?.showMobileUserInfoCard,
  )
</script>

<template>
  <aside
    class="w-full md:mr-6 md:w-[306px]"
    :aria-label="
      showMobileUserInfoCard && !isDesktop
        ? 'User details'
        : 'User details and desktop navigation sidebar'
    "
    data-testid="sidebar-container"
  >
    <UserInfoCard
      :class="
        cn('mb-4 sm:mb-6', showMobileUserInfoCard ? 'flex' : 'hidden md:flex')
      "
    />

    <div class="hidden md:block">
      <Card class="p-6">
        <SidebarItemsSkeleton v-if="isLoading" />
        <nav v-else aria-label="Sidebar navigation">
          <ul class="space-y-2" data-testid="sidebar-items">
            <template
              v-for="(
                { label, to, isDisabled, exact }, index
              ) in sidebarNavigationItems"
              :key="index"
            >
              <SidebarItem
                v-if="to"
                :to="to"
                :label="label"
                :disabled="isDisabled"
                :exact="exact"
              />
            </template>
          </ul>
        </nav>
      </Card>
    </div>
  </aside>
</template>
